export const INSTATUS_PAGE_URL = "https://waku-robotics.instatus.com";
export const INSTATUS_SUMMARY_URL = "https://waku-robotics.instatus.com/summary.json";
export const INSTATUS_MESSAGE_AUTOCLOSE = 10000;
export const INSTATUS_REFETCH_INTERVAL = 1 * 60 * 1000; // 1 minute
